(function excludeFromOwl($, Drupal, once) {
  Drupal.behaviors.excludeFromOwl = {
    observer: new ResizeObserver(entries => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.contentRect.height > 2) {
          entry.target.classList.remove('exclude-from-owl');
        } else if (entry.target.style.display !== 'none') {
          entry.target.classList.add('exclude-from-owl');
        }
      }
    }),

    attach: function excludeFromOwl(context) {
      // Sometimes things like hidden inputs in webforms mess up the nice,
      // uniform spacing that the owl classes give us. We try to protect
      // ourselves from this by giving any children elements of an owl class
      // that have <2px height the 'exclude-from-owl' class, which will remove
      // their margin-top to prevent them being given space they don't need.
      $(once(
        'excludeFromOwl',
        "[class*='u-o-'] > *:not(hr):not([hidden]):not([type='hidden']):not(.dont-exclude-from-owl)",
        context
      ))
        .each(function eachExcludeFromOwl() {
          const $this = $(this);
          const height = $this.height();

          if (height < 2) {
            if ($(this)[0].style.display !== 'none') {
              $this.addClass('exclude-from-owl');
            }
          }

          // Add a resize observer to remove our exclusion class if the
          // element height changes in the future, for example if content
          // is added, or a visibility class toggled.
          Drupal.behaviors.excludeFromOwl.observer.observe($this[0]);
        });
    },
  };
})(jQuery, Drupal, once);
